import mock from './mock'

import './chat2'


mock.onAny().passThrough()
   